var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimeline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 2.66656C13.4734 2.66656 13.4466 2.68 13.42 2.68656C13.3866 2.68 13.36 2.66656 13.3334 2.66656H12.6669V0.666562C12.6666 0.3 12.3666 0 12 0H2C1.01344 0 0.193438 0.72 0.0334375 1.66656C0.0134375 1.72 0 1.77344 0 1.83344V14.1669C0 15.18 0.82 16 1.83344 16H13.5C13.7734 16 14 15.7734 14 15.5V3.16656C14 2.89344 13.7734 2.66656 13.5 2.66656ZM7 13.6666C4.61344 13.6666 2.66656 11.72 2.66656 9.33313C2.66656 6.94625 4.61344 5 7 5C9.38656 5 11.3334 6.94656 11.3334 9.33344C11.3334 11.7203 9.38656 13.6666 7 13.6666ZM11.3334 2.66656H2C1.63344 2.66656 1.33344 2.36656 1.33344 2C1.33344 1.63344 1.63344 1.33344 2 1.33344H11.3334V2.66656Z",
    fill: "#499FD7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 11.0001C7.82942 11.0001 7.6588 10.9347 7.5288 10.8047L6.52881 9.80474C6.4035 9.68006 6.3335 9.51068 6.3335 9.33349V7.33349C6.3335 6.96474 6.63224 6.66693 7.00005 6.66693C7.36817 6.66693 7.66661 6.96506 7.66661 7.33349V9.05756L8.47129 9.86224C8.73191 10.1229 8.73191 10.5441 8.47129 10.8051C8.34129 10.9347 8.17067 11.0001 8.00004 11.0001Z",
    fill: "#499FD7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeline);
export default __webpack_public_path__ + "static/media/timeline.32050030.svg";
export { ForwardRef as ReactComponent };